import { memo, useEffect, useMemo } from 'react';

import type { IChatAppProps } from './ChatApp';
import App from './ChatApp';
import type MessageItem from './components/chat/model/message-item';
import ContextStorage, { StoreEmitter } from './context/Storage';
import './index.css';
import { CONTAINER_EVENT } from './utils/utils';

export { MessageItemType } from './components/chat/model/message-item';
export type { IConfig, INoLoginConfig, MindConfig, UserConfig, UserProfile } from './types/common';
export { EAppMode, EChatAppIds } from './utils/const';
export type { MessageItem };
export { CONTAINER_EVENT };

function Chat(props: IChatAppProps): JSX.Element | null {
  const storage = useMemo(() => new StoreEmitter(), []);

  useEffect(() => {
    console.log('123123123 [ChatApp] mounted', new Date().toISOString());

    return () => {
      console.log('123123123 [ChatApp] unmounted', new Date().toISOString());
    };
  }, []);

  return (
    <ContextStorage.Provider value={storage}>
      <App {...props} />
    </ContextStorage.Provider>
  );
}

export default memo(Chat);
